import { AttrField, NumberField, OrmModel, PrimaryKey, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.UNDO_REDO_HISTORY)
export default class UndoRedoHistory<State = unknown> extends BaseModel {
  @PrimaryKey()
  @StringField()
  public id: string

  // 0 - if there is no state yet,
  // 1 - if there is one state,
  // 1 or 2 - if there are two states,
  // 1 or 2 or 3 - if there are three states, etc.
  @NumberField(0)
  public currentStateSequence: number

  @AttrField([])
  public states: State[]
}
